import React, { useEffect, useState } from "react";
import { Grid, Icon, Loader, Tab } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import { isMobile } from "utils/isMobile";
import { getAllRoads } from "services/road";
import moment from "moment";
import AccordionRoads from "../components/AccordionRoads";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from "react-redux";

const styles = {
	containerStyle: {
		paddingTop: 30,
		marginTop: 40,
	},
	roundHeader: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		margin: "10px 0",
		color: "#fff",
		backgroundColor: "rgb(0, 157, 138)",
	},
	datePicker: {
		height: "100%",
		border: 0,
		background: "transparent",
		color: "#fff",
		fontWeight: 600,
	},
};
const DATE_FORMAT = "YYYY-MM-DD";
const TabPaneCT1 = ({ setOpenFolderManager }) => {
	const [selectedDate, setSelectedDate] = useState(moment().format(DATE_FORMAT));

	const road = useSelector((state) => state.road);
	const [initialLoading, setInitialLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		fetchRoads(selectedDate);
	}, []);

	const fetchRoads = async (date, force = false) => {
		setInitialLoading(true);
		await dispatch(getAllRoads(date, force));
		setInitialLoading(false);
	};

	const handleDateChange = (date) => {
		const formattedDate = moment(date).format(DATE_FORMAT);
		setSelectedDate(formattedDate);
		fetchRoads(formattedDate);
	};

	const goToFolderManager = (folderId) => {
		if (folderId) {
			dispatch({ type: "SET_FOCUSED_FOLDERS", payload: [folderId] }); // ou une vraie action
			setOpenFolderManager(true);
		}
	};

	if (initialLoading) {
		return (
			<div style={{ width: "100%", textAlign: "center", marginTop: "2em" }}>
				<Loader active inline />
			</div>
		);
	}
	const renderHeader = () => (
		<>
			<Grid.Column mobile={16} tablet={8} computer={8} style={styles.roundHeader}>
				<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
					<span style={{ fontWeight: "bold", width: 220 }}>
						{road.list.data.length === 0
							? "Aucune tournée trouvée"
							: road.list.data.length === 1
							? "Une tournée trouvée"
							: `${road.list.data.length} tournées trouvées`}
					</span>

					<Icon name="calendar alternate" size="large" />

					<DatePicker
						selected={new Date(selectedDate)}
						onChange={handleDateChange}
						className="datePicker"
						dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
						shouldCloseOnSelect
						onFocus={(e) => (e.target.readOnly = isMobile())}
						style={styles.datePicker}
					/>
				</div>
			</Grid.Column>
			<Grid.Column mobile={16} tablet={8} computer={8} style={{ textAlign: "right", paddingLeft: "1rem" }}>
				<MainButton
					text={<Icon name="redo" style={{ margin: 0 }} />}
					style={{ height: 40 }}
					onClick={(e) => {
						if (e) e.preventDefault();
						fetchRoads(selectedDate, true);
					}}
				/>
			</Grid.Column>
		</>
	);
	return (
		<Tab.Pane attached={false}>
			<Grid style={{ ...styles.roundHeader, marginBottom: "5rem" }}>
				{road.list.loading ? (
					<div style={{ width: "100%", textAlign: "center", marginTop: "2em" }}>
						<Loader active inline />
					</div>
				) : (
					<>
						{renderHeader()}
						{road.list.data.length > 0 && <AccordionRoads list={road.list.data} goToFolderManager={goToFolderManager} />}
					</>
				)}
			</Grid>
		</Tab.Pane>
	);
};

export default TabPaneCT1;
